import { CapabilityModelSchemaDataType } from 'src/app/shared/enumerations/capability-model-schema-data-type';
import { CapabilityModelSchemaType } from 'src/app/shared/enumerations/capability-model-schema-type';
import { IPropertyComment } from '../../../interfaces/PropertyComment.interface';
import { IColorScheme } from './color-scheme';

export interface ITelemetry extends IPropertyComment {
    id: string;
    name: string;
    type: TelemetryType;
    dataType: CapabilityModelSchemaDataType;
    unit: string;
    displayUnit: string;
    dcmUnit: string;
    displayName: { en: string; customerDefined?: string };
    capabilityModelSchemaType: CapabilityModelSchemaType;
    capabilityModelSchemaDisplayName: string;
    enumValues: Record<string, IEnum>;
    assetId: string;
    assetName?: string;
    viewState: ITelemetryViewState;
    unitIds: string[];
}

export enum ITelemetryViewState {
    Visible,
    Hidden,
    ZeroBased,
}

export interface IProperty extends IPropertyComment {
    id: string;
    name: string;
    dataType: CapabilityModelSchemaDataType;
    unit: string;
    displayUnit: string;
    displayName: IDisplayName;
    enumValues: Record<string, IEnum>;
    isComplex: boolean;
    parentId?: string;
}

export interface ICommand {
    commandType: number;
    request: IRequest;
    name: string;
    '@type': string;
    displayName: IDisplayName;
}

export interface IChartPropertyColor {
    name: string;
    value: string;
    colorScheme?: IColorScheme;
}

export enum TelemetryType {
    Input = 'input',
    Output = 'output',
}

export enum NumericTelemetryType {
    Input,
    Output,
}

export interface IDisplayName {
    en: string;
}

export interface IRequest {
    schema: IRequestSchema;
    '@type': string;
}

export interface IRequestSchema {
    fields: Field[];
    '@type': string;
}

export interface Field {
    name: string;
    schema: FieldSchema;
    displayName: IDisplayName;
}

export interface FieldSchema {
    '@type': Type;
    enumValues?: EnumValue[];
    valueSchema?: ValueSchema;
}

export enum Type {
    Boolean = 'boolean',
    Enum = 'Enum',
}

export interface EnumValue {
    enumValue: string;
    displayName: IDisplayName;
}

export interface ValueSchema {
    '@type': string;
}

export interface IEnum {
    title: string;
    properties: Record<string, string>;
}
